import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=c0227ca0"
import script from "./GroupDetail.vue?vue&type=script&lang=ts"
export * from "./GroupDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports